import { render, staticRenderFns } from "./RegistrarCliente.vue?vue&type=template&id=77ad90b0&scoped=true&"
import script from "./RegistrarCliente.vue?vue&type=script&lang=js&"
export * from "./RegistrarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad90b0",
  null
  
)

export default component.exports